angular.module('bmsApp.settings').controller('MobileSettingsCtrl', function ($scope,
																					   $q,
																					   $timeout,
																					   $filter,
																			 			AppSettingsSvc,
																					   notify) {

	var form = {
		validatorConfig: {
			submitHandler: function () {
				$timeout(function () {
					form.processing = true;
					self.errors = null;
					console.log($scope.appSettings);
					AppSettingsSvc.update($scope.appSettings)
						.then(function (response) {
							notify({
								message: 'Settings saved'
							});
						}, function (errors) {
							self.errors = errors;
						})
						.finally(function () {
							form.processing = false;
						})
					;
				});
			},
			errorPlacement: function (error, element) {
				// error.appendTo(element.parents('.reminder-schedule'));
			}
		},
		validatorApi: {},
		data: {},
		processing: false
	};

	var self = {
		savingSettings: false,
		methods: {
			init: function () {
				var promises = {
					appSettingsPromise: AppSettingsSvc.index()
						.then(function (response) {
							console.log(response);
							$scope.appSettings = response.data.settings;
						})
				};

				$q.all(promises)
					.then(function (responses) {

					}, function (errors) {
						self.errors = errors;
					})
					.finally(function () {
						self.loading = false;
					})
				;
			}
		},
		form: form,
		loading: true,
		errors: null
	};

	$scope.MobileSettingsCtrl = self;

});
